/**
 * @generated SignedSource<<6447673013a3080d80acf33bde4303cd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type paywallsGetArticlePaywallTagArticle$data = {
  readonly flag: string | null | undefined;
  readonly topics: ReadonlyArray<{
    readonly entityId: string;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpersIsArchiveWallArticle" | "helpersIsLiteWallArticle" | "helpersIsVelocityWallArticle" | "hooksVelocityWallThresholdABTest">;
  readonly " $fragmentType": "paywallsGetArticlePaywallTagArticle";
};
export type paywallsGetArticlePaywallTagArticle$key = {
  readonly " $data"?: paywallsGetArticlePaywallTagArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"paywallsGetArticlePaywallTagArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "paywallsGetArticlePaywallTagArticle"
};

(node as any).hash = "f7e83d098f48e03ed1e03c20cd011405";

export default node;
